<template>
  <div>
    <Breadcrumbs :type="type" :header="title" :url="url" :head="head"></Breadcrumbs>
    <trashed-message v-if="activityType.deleted_at" class="mb-6" @restore="restore"> This Stay Activity Type has been
      deleted. </trashed-message>
    <div class="max-w-lg bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/1"
            label="Name of Activity Type" required="true" placeholder="i.e " />
          <status-toogle-button v-model="form.status" :error="form.errors.status" label="Activity Type Status"
            class="pb-8 pr-6 w-full lg:w-1/1"></status-toogle-button>
          <status-toogle-button v-model="form.package" :error="form.errors.package" label="Is Package"
            class="pb-8 pr-6 w-full lg:w-1/1"></status-toogle-button>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!activityType.deleted_at && permission.edit > 0" class="text-red-600 hover:underline"
            tabindex="-1" type="button" @click="destroy"><delete-icon></delete-icon></button>
          <Button v-if="permission.edit > 0" :type="type" :name="head" :url="createUrl"
            :loading="form.processing"></Button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, toRefs, inject } from 'vue'
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import DeleteIcon from '@/Shared/DeleteIcon'
import Button from '@/Shared/Button'
export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    StatusToogleButton,
    Breadcrumbs,
    DeleteIcon,
    Button
  },
  layout: Layout,
  props: {
    activityType: Object,
    permission: Object,
  },
  remember: 'form',
  setup(props) {
    const { activityType, permission } = toRefs(props)
    const type = ref('edit')
    const title = ref(activityType.value.title)
    const head = ref('Stay Activity Type')
    const url = ref('/backend/stay-activity-types')
    const createUrl = ref('')
    const swal = inject('$swal')
    const elm = ref(this)
    const form = useForm({
      title: activityType.value.title,
      package: activityType.value.package,
      status: activityType.value.status
    })
    const update = () => {
      swal({
        title: 'Are you sure?',
        text: "You want to proceed with this action",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          form.put(`${url.value}/${activityType.value.id}`)
          title.value = form.title
          swal.fire(
            'Updated!',
            'Your infomation has been Updated.',
            'success'
          )
        }
      });
    }
    const destroy = () => {
      swal({
        title: 'Are you sure?',
        text: "Do you really want to delete this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          form.delete(`${url.value}/${activityType.value.id}`)
          swal.fire(
            'Deleted!',
            'Your infomation has been deleted.',
            'success'
          )
        }
      });
    }
    const restore = () => {
      swal({
        title: 'Are you sure?',
        text: "You want to restore this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Resore it!'
      }).then((result) => {
        if (result.isConfirmed) {
          form.put(`${url.value}/${activityType.value.id}/restore`)
          swal.fire(
            'Restored!',
            'Your infomation has been Restored.',
            'success'
          )
        }
      });
    }
    const statusCheck = () => {
      if (activityType.value.status == 1) {
        form.status = true;
        return true;
      } else {
        form.status = false;
        return false;
      }
    }
    return {
      form,
      activityType,
      type,
      title,
      head,
      url,
      createUrl,
      update,
      destroy,
      restore,
      statusCheck,
      swal,
      permission
    }
  },
  created: function () {
    this.statusCheck();
  }

}
</script>
